import classNames from 'classnames';
import * as React from 'react';
import Overlay, { OverlayProps } from '../../atoms/Overlay';
import Text from '../../atoms/Text';
import Button from '../../atoms/Button';

import styles from './FAB.module.scss';
import Surface from '../../atoms/Surface';

export interface Props extends React.HTMLAttributes<HTMLElement> {
  placement?: 'bottom-right' | 'top-right' | 'bottom-left' | 'top-left';
  tooltipPlacement?: OverlayProps['placement'];
  label?: string;
  children: React.ReactNode;
  options?: (dismiss: () => void) => React.ReactNode;
  onClick?: () => void;
}

const FAB: React.FunctionComponent<Props> = ({
  className,
  style,
  placement = 'bottom-right',
  tooltipPlacement = 'left',
  options,
  label = '',
  children,
  onClick,
  ...htmlElementProps
}) => {
  const [showTooltip, setShowTooltip] = React.useState(false);
  const [target, setTarget] = React.useState<HTMLElement | null>(null);
  const [show, setShow] = React.useState(false);

  const btnRef = React.useRef<HTMLDivElement | null>(null);

  const cls = classNames(styles.wrapper, className, placement);

  return (
    <div className={cls} {...htmlElementProps} ref={btnRef}>
      <Button
        onMouseEnter={(event) => {
          setTarget(event.target as HTMLElement);
          setShowTooltip(true);
        }}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={options ? () => setShow(true) : () => onClick?.()}
      >
        {children}
      </Button>

      <Overlay
        target={target}
        show={showTooltip}
        placement={tooltipPlacement}
        onHide={() => null}
        role="tooltip"
      >
        <div className={styles.tooltip}>
          <Text as="span" color="grayLight1">
            {label}
          </Text>
        </div>
      </Overlay>

      {show && (
        <Overlay
          show={show}
          placement="left-end"
          target={btnRef.current}
          onHide={() => setShow(false)}
          tooltip
        >
          <Surface
            className={styles.popover}
            backgroundColor="grayLight3"
            padding="xs"
          >
            {options?.(() => setShow(false))}
          </Surface>
        </Overlay>
      )}
    </div>
  );
};

export default FAB;
